export default __webpack_public_path__ + "static/media/icon_diversity_white.2523cfcf.svg";